var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g, _path44, _path45, _g2, _path46, _path47, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1808 83.6707C72.6279 83.6707 90.0142 66.2844 90.0142 44.8373C90.0142 23.3902 72.6279 6.00391 51.1808 6.00391C29.7337 6.00391 12.3474 23.3902 12.3474 44.8373C12.3474 66.2844 29.7337 83.6707 51.1808 83.6707Z",
    fill: "#2A2E37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.099 87.4535H8.7666L37.463 48.9227L49.7686 32.5824L60.5109 44.2324L62.5786 46.4514L85.6769 14.4769L95.5618 0.80957L103.278 12.0561L129.554 50.3348L140.145 38.2309L145.541 32.0276L150.13 37.5248L193.099 87.4535Z",
    fill: "#5C6479"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7686 32.5825L49.2643 87.4536H8.7666L37.463 48.9228L49.7686 32.5825Z",
    fill: "#474E61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5619 0.80957L93.8976 81.7041L62.5787 46.4514L95.5619 0.80957Z",
    fill: "#474E61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.499 79.5357L129.554 50.335L145.541 32.0278L146.499 79.5357Z",
    fill: "#474E61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 87.4536H49.2644H193.099H199",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.094 95.6235H117.904",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.397 95.6235H153.207",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.58 95.6235H135.303",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4993 95.6235H93.3933",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1329 95.6235H33.9327",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.549 95.6235H191.687",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67297 95.6235H19.3576",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1804 102.432H66.8656",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8228 102.432H132.58",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.988 102.432H186.745",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8945 102.432H89.7116",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.535 109.19H164.806",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5487 109.19H105.094",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3928 109.19H66.8656",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7714 109.19H45.482",
    stroke: "#3D4550",
    strokeWidth: 1.51299,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.328 74.3914C68.328 77.5687 65.7559 78.9808 62.6291 78.9808C59.5023 78.9808 56.9302 77.5687 56.9302 74.3914C56.9302 71.2141 62.6291 51.5957 62.6291 51.5957C62.6291 51.5957 68.328 71.2646 68.328 74.3914Z",
    fill: "#B5BECF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5786 68.8438V86.8483",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5786 71.9705L64.6464 70.1045",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5787 76.2578L59.6031 72.7275",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M119.568 72.9791C119.568 76.5094 116.693 78.0729 113.213 78.0729C109.683 78.0729 106.859 76.5094 106.859 72.9791C106.859 69.4488 113.213 47.6113 113.213 47.6113C113.213 47.6113 119.568 69.4993 119.568 72.9791Z",
    fill: "#B5BECF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M113.214 66.7759V86.8482",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M113.214 70.3062L115.483 68.188",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M113.213 75.097L109.885 71.1128",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M140.246 78.3761C140.246 80.5448 138.48 81.503 136.362 81.503C134.194 81.503 132.479 80.5448 132.479 78.3761C132.479 76.2075 136.362 62.8428 136.362 62.8428C136.362 62.8428 140.246 76.2075 140.246 78.3761Z",
    fill: "#B5BECF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.312 74.5938V86.849",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M136.312 76.712L137.724 75.4512",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M136.312 79.6371L134.294 77.2163",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M161.074 75.9549C161.074 78.7287 158.855 79.9391 156.081 79.9391C153.308 79.9391 151.089 78.7287 151.089 75.9549C151.089 73.1811 156.081 55.9834 156.081 55.9834C156.081 55.9834 161.074 73.1811 161.074 75.9549Z",
    fill: "#B5BECF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 71.063V86.8485",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 73.7862L157.847 72.1724",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 77.5687L153.459 74.4419",
    stroke: "#7D87A0",
    strokeWidth: 1.00866,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M63.0326 46.7542L54.3581 47.5107L50.3235 51.6462L45.4819 50.7888L37.4631 55.7817L34.9414 52.5036L49.92 32.5825L63.0326 46.7542Z",
    fill: "#A9AFC3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M107.212 17.7551L103.127 16.8473L98.941 18.8142L95.5619 17.9568L92.3342 23.7062L87.2909 21.3358L81.6424 23.7062L80.6842 21.4871L95.5619 0.80957L107.212 17.7551Z",
    fill: "#A9AFC3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M152.803 40.4501L148.567 43.7787L144.633 41.6101L139.086 44.8378L137.522 41.4588L145.743 32.0278L152.803 40.4501Z",
    fill: "#A9AFC3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9357 17.6544C46.7427 17.4527 47.4992 17.4023 48.3061 17.4023C49.0626 17.4023 49.8695 17.4527 50.626 17.5536C51.3825 17.6544 52.1894 17.8562 52.9459 18.2092C53.7024 18.5622 54.4589 19.0665 54.9128 19.9239L54.0555 19.7222L54.9633 19.0161C55.3163 18.8144 55.6189 18.5622 55.9215 18.3605C56.5771 17.957 57.2832 17.604 58.0397 17.3518C58.7962 17.0997 59.5527 16.8979 60.3091 16.7971C61.1161 16.7466 61.8726 16.7466 62.6795 16.9484C62.8308 16.9988 62.8812 17.1501 62.8308 17.251C62.7804 17.4023 62.6795 17.4527 62.5282 17.4023H62.4778C61.8221 17.251 61.0656 17.3014 60.3596 17.4023C59.6535 17.5031 58.9475 17.7553 58.2918 18.0579C57.6362 18.3605 57.031 18.7135 56.4258 19.117C56.1232 19.3187 55.8206 19.5709 55.5684 19.7726L54.7615 20.4787C54.5094 20.6804 54.2068 20.63 54.005 20.4282L53.9546 20.4787L53.9042 20.3778C53.7024 19.823 53.1477 19.3691 52.5425 19.0665C51.9373 18.7639 51.2312 18.5118 50.4747 18.3605C49.7687 18.2092 49.0122 18.1083 48.2557 18.0579C47.4992 18.0075 46.7427 18.0075 46.087 18.1588H46.0366C45.8853 18.2092 45.7844 18.1083 45.734 17.957C45.734 17.8057 45.7844 17.6544 45.9357 17.6544Z",
    fill: "#5C6479"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5435 31.4733C24.3505 31.2715 25.107 31.2211 25.9139 31.2211C26.6704 31.2211 27.4773 31.2715 28.2338 31.3724C28.9903 31.4733 29.7972 31.675 30.5537 32.028C31.3102 32.3811 32.0667 32.8854 32.5206 33.7428L31.6632 33.541L32.571 32.835C32.9241 32.6332 33.2267 32.3811 33.5293 32.1793C34.1849 31.7759 34.891 31.4228 35.6475 31.1707C36.4039 30.9185 37.1604 30.7168 37.9169 30.6159C38.7239 30.5655 39.4804 30.5655 40.2873 30.7672C40.4386 30.8176 40.489 30.9689 40.4386 31.0698C40.3882 31.2211 40.2873 31.2715 40.136 31.2211H40.0856C39.4299 31.0698 38.6734 31.1202 37.9674 31.2211C37.2613 31.322 36.5552 31.5741 35.8996 31.8767C35.244 32.1793 34.6388 32.5324 34.0336 32.9358C33.731 33.1376 33.4284 33.3897 33.1762 33.5915L32.3693 34.2975C32.1171 34.4993 31.8145 34.4488 31.6128 34.2471L31.5624 34.1967L31.5119 34.0958C31.3102 33.541 30.7554 33.0871 30.1503 32.7845C29.5451 32.4819 28.839 32.2298 28.0825 32.0785C27.3764 31.9272 26.6199 31.8263 25.8634 31.7759C25.107 31.7254 24.3505 31.7254 23.6948 31.8767H23.6444C23.4931 31.9272 23.3922 31.8263 23.3418 31.675C23.3418 31.6246 23.4427 31.4733 23.5435 31.4733Z",
    fill: "#5C6479"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3825 29.506C52.1894 29.3043 52.9459 29.2538 53.7529 29.2538C54.5094 29.2538 55.3163 29.3043 56.0728 29.4051C56.8293 29.506 57.6362 29.7077 58.3927 30.0607C59.1492 30.4138 59.9057 30.9181 60.3596 31.7755L59.5022 31.5737L60.41 30.8677C60.7631 30.6659 61.0657 30.4138 61.3683 30.212C62.0239 29.8086 62.7299 29.4556 63.4864 29.2034C64.2429 28.9512 64.9994 28.7495 65.7559 28.6486C66.5629 28.5982 67.3194 28.5982 68.1263 28.7999C68.2776 28.8504 68.328 29.0017 68.2776 29.1025C68.2271 29.2538 68.1263 29.3043 67.975 29.2538H67.9245C67.2689 29.1025 66.5124 29.153 65.8064 29.2538C65.1003 29.3547 64.3942 29.6069 63.7386 29.9094C63.083 30.212 62.4778 30.5651 61.8726 30.9685C61.57 31.1703 61.2674 31.4224 61.0152 31.6242L60.2083 32.3302C59.9561 32.532 59.6535 32.4815 59.4518 32.2798L59.4014 32.2294L59.3509 32.1285C59.1492 31.5737 58.5944 31.1198 57.9892 30.8172C57.384 30.5146 56.678 30.2625 55.9215 30.1112C55.2154 29.9599 54.4589 29.859 53.7024 29.8086C52.9459 29.7581 52.1894 29.7582 51.5338 29.9094H51.4834C51.3321 29.9599 51.2312 29.859 51.1808 29.7077C51.1808 29.6573 51.2312 29.506 51.3825 29.506Z",
    fill: "#5C6479"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17359_2538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.479 30.195C132.479 33.0974 130.132 35.4445 127.204 35.4445C127.154 35.4445 126.725 35.4445 123.57 35.4445C121.374 35.4445 117.866 35.4445 112.263 35.4445H109.588C106.08 35.5202 103.278 32.7188 103.278 29.3369C103.278 25.9297 106.105 23.103 109.664 23.2797C112.717 13.7396 126.699 15.0772 127.886 24.9454C130.51 25.2735 132.479 27.4945 132.479 30.195Z",
    fill: "#5C6479"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M118.598 35.4958C123.772 35.4958 127.986 31.3063 127.986 26.1324C127.986 20.9586 123.772 16.769 118.598 16.769C113.424 16.769 109.209 20.9586 109.209 26.1324C109.209 31.3063 113.399 35.4958 118.598 35.4958Z",
    fill: "url(#paint0_linear_17359_2538)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M127.204 35.4454C130.107 35.4454 132.479 33.0982 132.479 30.1958C132.479 27.2934 130.107 24.9463 127.204 24.9463C124.302 24.9463 121.929 27.2934 121.929 30.1958C121.929 33.0982 124.302 35.4454 127.204 35.4454Z",
    fill: "url(#paint1_linear_17359_2538)",
    fillOpacity: 0.37
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17359_2538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.6574 39.4302C86.6574 41.6179 84.8882 43.3872 82.6814 43.3872C82.6433 43.3872 82.3199 43.3872 79.9419 43.3872C78.2869 43.3872 75.6425 43.3872 71.4192 43.3872H69.4027C66.7584 43.4442 64.6467 41.3326 64.6467 38.7834C64.6467 36.2151 66.7774 34.0845 69.4598 34.2176C71.7617 27.0266 82.3009 28.0349 83.195 35.4732C85.1735 35.7205 86.6574 37.3946 86.6574 39.4302Z",
    fill: "#5C6479"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1942 43.4253C80.0941 43.4253 83.2711 40.2673 83.2711 36.3674C83.2711 32.4675 80.0941 29.3096 76.1942 29.3096C72.2943 29.3096 69.1173 32.4675 69.1173 36.3674C69.1173 40.2673 72.2753 43.4253 76.1942 43.4253Z",
    fill: "url(#paint2_linear_17359_2538)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6813 43.3876C84.8691 43.3876 86.6573 41.6184 86.6573 39.4306C86.6573 37.2429 84.8691 35.4736 82.6813 35.4736C80.4936 35.4736 78.7053 37.2429 78.7053 39.4306C78.7053 41.6184 80.4936 43.3876 82.6813 43.3876Z",
    fill: "url(#paint3_linear_17359_2538)",
    fillOpacity: 0.37
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17359_2538",
    x: 96.722,
    y: 15.7824,
    width: 42.3133,
    height: 31.7674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.54763
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27815
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17359_2538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17359_2538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17359_2538",
    x: 58.0904,
    y: 28.318,
    width: 35.1232,
    height: 27.1741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.54763
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27815
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17359_2538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17359_2538",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17359_2538",
    x1: 111.497,
    y1: 20.6587,
    x2: 114.641,
    y2: 23.0887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80889D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#5C6479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17359_2538",
    x1: 121.356,
    y1: 23.8326,
    x2: 126.024,
    y2: 28.9496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17359_2538",
    x1: 70.8421,
    y1: 32.2415,
    x2: 73.2119,
    y2: 34.0732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80889D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#5C6479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17359_2538",
    x1: 78.2733,
    y1: 34.6341,
    x2: 81.792,
    y2: 38.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d278c130b09b7560d6553203fdcee0fe.svg";
export { ForwardRef as ReactComponent };